// const baseUrl = 'https://online.server.zyyunxun.cn/jiti';  //正式服请求地址前缀
// const baseUrl = 'http://192.168.2.7:8081'; //本地请求地址前缀
// const baseUrl = 'https://server.zyyunxun.cn';  //测试服请求地址前缀
const baseUrl = 'https://online.new.zyyunxun.cn:8082';  //新版正式服

//oss访问地址
const ossUrl = 'http://online.file.zyyunxun.cn/'  //正式服oss
// const ossUrl = 'http://test.file.zyyunxun.cn/' //测试服oss 


//前端访问地址--电子证书/股权证---h5地址
// const url = 'https://online.zyyunxun.cn/'  //正式服

//电子投票报告
// const url = ' https://test.zyyunxun.cn/h5/index.html#/'      //测试服
const url = ' https://online.zyyunxun.cn/h5/index.html#/'      //正式服

// const url = 'http://192.168.2.7:8083/'
export default {
    baseUrl,
    ossUrl,
    url 
}